import AuditBsk from './audit-bsk'
import ExportOrder from './export-order'
import Invoice from './invoice'

export default {
    path: 'finance',
    component: () => import('@layout/empty'),
    children: [
        AuditBsk,       //核实标书款
        ExportOrder,    //导出标书款收入
        Invoice,
    ]
}
